// extracted by mini-css-extract-plugin
export default {"csdBlueFlow":"login_csdBlueFlow__en-2-","csdPurpleFlow":"login_csdPurpleFlow__vjMi+"};